export default __webpack_public_path__ + "static/960aaab7305a9b530407eadd83dd06a3.jpg";